module.exports = __webpack_public_path__ + "img/avatarSelected.1ac56433.png";